<div *ngIf="isAdmin && showWeatherOptions">
  <div class="row content-wrapper mb-2">
    <div class="col-12 mb-2 pl-0">
      <span class="heading-text">{{ T.dashboard.chose_temperature_unit | translate }}</span>
    </div>
    <div class="col-12 mb-3 pl-0">
      <app-simple-dropdown
        bindProperty="value"
        [objects]="temperatureOptions"
        [currentlySelectedObject]="selectedTemperatureOption"
        (objectSelected)="onTemperatureOptionChange($event)"
      >
      </app-simple-dropdown>
    </div>
  </div>
  <ng-container *ngIf="dashboardWeatherLocations">
    <div class="row content-wrapper locations-wrapper">
      <div class="col-12 mb-2 pl-0">
        <span class="heading-text">{{ T.dashboard.set_weather_locations | translate }}</span>
      </div>
      <div class="col-12 mb-3 pl-0">
        <div class="weather-location-table" *ngFor="let w of dashboardWeatherLocations; let i = index">
          <div class="title">
            <span [title]="w.location.locationDetails">{{ w.location.locationDetails }}</span>
          </div>
          <div class="right">
            <a (click)="onMakeDefault(w)" class="location-link mr-2">
              <i class="material-symbols-outlined location-icons default" *ngIf="w.isDefault">star</i>
              <i class="material-symbols-outlined location-icons" *ngIf="!w.isDefault">star_border</i>
            </a>
            <a (click)="onRemoveWeatherLocation(i)" class="location-link">
              <i class="material-symbols-outlined location-icons delete">delete_forever</i>
            </a>
          </div>
        </div>
      </div>
      <div class="locations-buttons-container">
        <app-button-rectangle
          [text]="T.common.add | translate"
          [buttonTheme]="'white'"
          (clicked)="addWeatherLocation()">
        </app-button-rectangle>
        <app-button-rectangle *ngIf="showWeatherLocationUpdateButton"
          [text]="T.common.update | translate"
          [buttonTheme]="'primary'"
          (click)="updateWeatherLocations()"
        >
        </app-button-rectangle>
      </div>
    </div>
  </ng-container>
</div>
